import { Box } from '@mui/material';
import { Container } from '@mui/system';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ActionCellPopup from '../../components/ActionCellPopup/ActionCellPopup';
import ChipLocal from '../../components/Chip/Chip';
import Link from '../../components/Link/Link';
import Progress from '../../components/Progress/Progress';
import { PATHS, bundleCountryCodeMapping, countiesMapping } from '../../utils/constants';
import { useAppSelector } from '../../hooks/useRedux';
// import ButtonPopper from '../../components/ButtonPopper/ButtonPopper';

export const LinkCell = ({ value }: any) => <Link to={PATHS.vahicle(value)}> {value} </Link>;

export const TagCell = ({ value, ...otherParams }: any) => {
  return (
    value && (
      <Box py={1}>
        <ChipLocal text={value} disabled={otherParams.disabled ?? false} sx={otherParams.sx || {}} />
      </Box>
    )
  );
};

export const ActionCell = ({ value, ...otherParams }: any) => {
  // console.log('getting toggle popper...............', otherParams);

  return (
    value && (
      <Box py={1}>
        {/* <ButtonPopper
          text={value}
          disabled={otherParams.disabled ?? false}
          sx={otherParams.sx || {}}
          actionRef={otherParams.actionRef}
          actionPopperId={otherParams.actionPopperId}
          canBeActionOpen={otherParams.canBeActionOpen}
          anchorEl={otherParams.anchorEl}
          onClickAction={otherParams.onClickAction}
          handleActionChangeType={otherParams.handleActionChangeType}
        /> */}
        <ActionCellPopup
          text={value}
          disabled={otherParams.disabled ?? false}
          sx={otherParams.sx || {}}
          handleActionChangeType={otherParams.handleActionChangeType}
        />
        {/* {otherParams.disabled === true ? (
          <Box sx={{ border: `1px solid #bbbab7`, borderRadius: 1, color: '#bbbab7', padding: '8px' }}> ... </Box>
        ) : (
          <Box
            // ref={otherParams.anchorRef}
            // size="small"
            sx={{ borderRadius: 1, border: '1px solid #456BD9', padding: '8px' }}
            onClick={() => otherParams.handleActionChangeType()}
          >
            ...
          </Box>
        )} */}
        {/* <Popper
          id={otherParams.actionPopperId}
          open={otherParams.canBeActionOpen}
          anchorEl={otherParams.anchorEl}
          transition
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              timeout={350}
              style={{
                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <MenuList
                  autoFocusItem={otherParams.canBeActionOpen}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                >
                  <MenuItem onClick={() => otherParams.handleActionChangeType()}>
                    <Typography variant="body2">Change Assignment Type</Typography>
                  </MenuItem>
                </MenuList>
              </Paper>
            </Grow>
          )}
        </Popper> */}
      </Box>
    )
  );
};

export const DateCell = ({ value }: any) => value && moment(value).format('MMM DD, YYYY');

export const ProgressCell = ({ value }: any) => <Progress progress={value} />;

type ICountryCellCellProp = {
  value: string;
};

export const CountryCell = ({ value }: ICountryCellCellProp) => {
  const [country, setCountry] = useState<string>('--');

  useEffect(() => {
    if (value) {
      const existCountry = countiesMapping.find(
        (val) => val.localeCode.split('-')[1]?.toLowerCase() === value.toLowerCase()
      );
      if (existCountry?.name) {
        setCountry(existCountry?.name);
      }
    }
  }, [value]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{country}</>;
};

export interface IVehiclePrice {
  taxAmount: number;
  taxPercentage: number;
  basePriceWithoutUpgrades: number;
  value: number;
  currency: string;
  totalBasePrice: number;
  totalPrice: number;
  locale: string;
  createdAt: Date;
  updatedAt: Date;
}

type ICurrencyDropDownCellProp = {
  value: string;
  data: any;
};

export const CurrencyDropDownCell = ({ value, data }: ICurrencyDropDownCellProp) => {
  const [currentPrice, setCurrentPrice] = useState<string>('');
  const selectedLocales = useAppSelector((state) => state.locale.selectedLocales);

  useEffect(() => {
    if (data.vehiclePrice && data.vehiclePrice.length > 0) {
      const vehiclePricesData: IVehiclePrice[] = data.vehiclePrice;

      // The distinct markets (region codes) the vehicle is priced for, e.g.
      // both "en-ca" and "fr-ca" resolve to the single market "ca".
      const pricedRegions = new Set(
        vehiclePricesData.map((val) => val.locale?.split('-')[1]?.toLowerCase()).filter(Boolean)
      );

      // The selected locales' region codes, e.g. ["us", "de"].
      const selectedRegions = selectedLocales.map((locale) => locale.split('-')[1]?.toLowerCase());

      // The price for a selected market the vehicle actually has a price for.
      const matchedPrice = vehiclePricesData.find((val: IVehiclePrice) =>
        selectedRegions.includes(val.locale?.split('-')[1]?.toLowerCase())
      );

      // One-to-one: the vehicle is priced for a single market. Always show that
      // available price so the slot is never empty, regardless of the locale
      // selected in the header. One-to-many: only show a matching market.
      const isSingleMarket = pricedRegions.size === 1;
      const currentValue = isSingleMarket ? matchedPrice ?? vehiclePricesData[0] : matchedPrice;

      if (currentValue) {
        const { currency } = currentValue;
        setCurrentPrice(new Intl.NumberFormat('en', { style: 'currency', currency }).format(currentValue.totalPrice));
      } else {
        setCurrentPrice('');
      }
    } else {
      setCurrentPrice('');
    }
  }, [data, selectedLocales]);

  return (
    <Container disableGutters sx={{ m: 0 }}>
      {currentPrice ? <Box sx={{ textAlign: 'left' }}>{currentPrice}</Box> : '--'}
    </Container>
  );
};

type IBundleName = {
  technicalName: string;
  locale: string;
  sapCode?: string;
  zlCode?: string;
};

type IBundleCellProp = {
  data: any;
};

export const BundleCell = ({ data }: IBundleCellProp) => {
  const selectedLocales = useAppSelector((state) => state.locale.selectedLocales);

  const bundleNames: IBundleName[] = data?.bundleNames ?? [];

  // The distinct markets (region codes) the vehicle has bundles for, e.g.
  // both "en-ca" and "fr-ca" resolve to the single market "ca".
  const bundleRegions = new Set(bundleNames.map((val) => val.locale?.split('-')[1]?.toLowerCase()).filter(Boolean));

  // The selected locales' region codes, e.g. ["us", "de"].
  const selectedRegions = selectedLocales.map((locale) => locale.split('-')[1]?.toLowerCase());

  // The bundle for a selected market the vehicle actually has a bundle for.
  const matchedBundle = bundleNames.find((val) => selectedRegions.includes(val.locale?.split('-')[1]?.toLowerCase()));

  // One-to-one: the vehicle has a bundle for a single market. Always show that
  // available bundle so the slot is never empty, regardless of the locale
  // selected in the header. One-to-many: only show a matching market.
  const isSingleMarket = bundleRegions.size === 1;
  const currentBundle = isSingleMarket ? matchedBundle ?? bundleNames[0] : matchedBundle;
  const bundleName: string = currentBundle?.technicalName ?? '';

  return (
    <Container disableGutters sx={{ m: 0 }}>
      {bundleName ? <Box sx={{ textAlign: 'left' }}>{bundleName}</Box> : '--'}
    </Container>
  );
};
